import { Link } from 'react-router-dom';

import avatar from '../images/avatar.jpg';
export default function SakrebuloCard({
	index,
	slug,
	image,
	full_name,
	position,
	url,
}) {
	return (
		<div className='landing-items-container-infos' key={index}>
			<Link to={`/${url}/${slug}`}>
				<div className='new-image-wrapp'>
					<img src={image ? image : avatar} alt='' />
				</div>
				<div>
					<span className='time'>{full_name}</span>
					<span className='header'>{position}</span>
				</div>
			</Link>
		</div>
	);
}
